/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

// import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';
import { startProgress, stopProgress } from './progress-util.js';


// default - is overriden by initManjaBackendFetch()
let m_showErrorToast = function( msg ) {
	// eslint-disable-next-line no-console
	console.log(msg);
};

let m_initManjaBackendFetch_called = false;

function initManjaBackendFetch( showErrorToastFn, ondone ) {
	if( m_initManjaBackendFetch_called ) {
		if( ondone ) {
			ondone();
		}
		return;
	}
	m_initManjaBackendFetch_called = true;

	m_showErrorToast = showErrorToastFn;
	// ajax config
	jQuery.ajaxSetup( {
		cache: false,
		scriptCharset: 'UTF-8',
		timeout: 30*60*1000,
		error: default_ajax_error_handler,
		beforeSend: function( xhr, settings ) {
			if( window.mj.csrf_token && !settings.crossDomain && ( settings.type=='POST' || settings.type=='PUT' || settings.type=='DELETE' ) ) {
				xhr.setRequestHeader('X-CSRF-Token',window.mj.csrf_token);
				if( window.mj.is_guest_session ) {
					xhr.setRequestHeader('X-CSRF-From-Guest-Session','1');
				}
			}
			// apply base url ...
			var u = settings.url;
			if( u.length > 1 && ( u.startsWith('json/') || u.startsWith('json-api/') ) ) {
				settings.url = (window.mj.webroot||'/') + u;
			}
		},
	} );
	if( ondone ) {
		ondone();
	}
}


function default_ajax_error_handler( jqXHR, textStatus, message ) {
	stopProgress();
	if( textStatus=='timeout' ) {
		m_showErrorToast('AJAX timeout');
	} else if( textStatus=='error' ) {
		default_ajax_error_handler_error(jqXHR,message);
	} else if( textStatus=='notmodified' ) {
		//m_showErrorToast('AJAX cache hit');
	} else if( textStatus=='parseerror' || textStatus=='parsererror' ) {
		if( jqXHR.responseText ) m_showErrorToast('AJAX error response: '+jqXHR.responseText);
		else m_showErrorToast('AJAX error parsing response');
	} else if( textStatus=='abort' ) {
		/* do not show message */
	} else {
		m_showErrorToast('AJAX: unknown error ('+textStatus+': '+jqXHR.status+')' + (message?' - '+message:''));
	}
}

function default_ajax_error_handler_error( jqXHR, message ) {
	if( jqXHR.status==414 ) {
		m_showErrorToast('Fehler! Konnte die Anfrage nicht ausführen. Bitte Auswahl verkleinern.'); // Request-URI too large..
		return;
	}
	var r = jqXHR.responseJSON;
	if( r && r.logout ) {
		mj_handle_invalid_session(r);
	} else if( r && r.error ) {
		if( jqXHR.status==500 && message=='Internal Server Error' ) {
			// HTTP 500 "Internal Server Error" is too general ...
			// -> we already know that we have details in r.error
			// -> remove HTTP message
			message = '';
		}
		if( r.message ) message = r.message;
		default_ajax_app_error_handler(r.error+(message?' - '+message:''),r);
	} else if( jqXHR.status!==0 || typeof r !== 'undefined' ) {
		m_showErrorToast('AJAX error ('+jqXHR.status+')'+(message?' - '+message:''));
	}
	// NOTE: status===0 && typeof r === 'undefined' usually is the case when a request was aborted - dont show that in UI
}

function default_ajax_app_error_handler( server_msg, r ) {
	stopProgress();
	if( r && r.error_details ) {
		try {
			const d = JSON.parse(r.error_details);
			if( d.logout ) {
				return mj_handle_invalid_session(r);
			}
		} catch( err ) {
			// empty
		}
	}
	m_showErrorToast('AJAX error response: '+server_msg);
}

function intercept_ajax_backend_errors( jqXHR, textStatus, ajaxSettings ) {
	if( window.mj.backend_exception_hook && textStatus==='error' ) {
		var r = jqXHR.responseJSON;
		if( r && r.error && r.error_is_backend_exception ) {
			const triggerErrorUI = ajaxSettings.triggerErrorUI ?? true;
			window.mj.backend_exception_hook(r,ajaxSettings.type,ajaxSettings.url,ajaxSettings.data,triggerErrorUI);
		}
	}
}

function mj_handle_invalid_session( resp ) {
	// TODO: provide better feedback to user
	const e = resp.error;
	var 														txt = mjt('err-mjUserAuthenticationRequiredError');
	if( e==='mjSessionGoneError' )								txt = mjt('err-mjSessionGoneError');
	else if( e==='mjSessionChangedError' )						txt = mjt('err-mjSessionChangedError');
	else if( e==='mjPermissionNotGrantedInGuestSessionError' )	txt = mjt('err-mjPermissionNotGrantedInGuestSessionError');
	else if( e==='mjHigherPermissionsExpectedError' )			txt = mjt('err-mjHigherPermissionsExpectedError');
	else if( e==='mjCSRFValidationError' )						txt = mjt('err-mjCSRFValidationError');
	else if( e==='mjFunctionNotAvailableError' )				txt = mjt('err-mjFunctionNotAvailableError');
	if( resp.message ) txt += ': '+resp.message;
	m_showErrorToast(txt);
	let req = '?error='+encodeURIComponent(e)
			+ '&message='+encodeURIComponent(resp.message||'')
			+ '&error_details='+encodeURIComponent(resp.error_details||'');
	let redirectToModuleSpec = (resp.logout??false) ? 'login' : 'init';
	if( redirectToModuleSpec==='login' && ( e==='mjSessionChangedError' || e==='mjCSRFValidationError' ) ) {
		// redirect to /init - do not trigger an actual logout (as redirect to /login would do)
		redirectToModuleSpec = 'init';
	}
	let req_extra = new URLSearchParams(window.location.search);
	if( req_extra.has('mj_svdreq') ) {
		// pass-through ...
		req += '&mj_svdreq='+encodeURIComponent(req_extra.get('mj_svdreq'));
	} else {
		if( window.mj.path_request ) {
			for( const [k,v] of Object.entries(window.mj.path_request) ) req_extra.set(k,v);
		}
		// req_extra.set('m',mj.module.module+(mj.module.section?'.'+mj.module.section:''));
		req_extra.delete('privCacheJsResponse');
		req_extra.delete('error_details');
		if( req_extra.size ) req += '&mj_svdreq='+encodeURIComponent(req_extra.toString());
	}
	const url = window.mj.uwn+'/'+redirectToModuleSpec+req;
	setTimeout( function() {
		document.location.replace(url);
	}, 3000 );
}








function checkedManjaURL( url ) {
	url = window.mj.fixJsonURL(url);

	if( url.startsWith('json/') ) {
		url = window.mj.webroot + url;
	}
	return url;
}

function postToBackend( url, data, success_callback, default_handle_errors, complete_callback, extra_settings ) {
	return postToBackend2(url,data,success_callback,null,default_ajax_error_handler,default_handle_errors,complete_callback,extra_settings);
}

function postToBackend2( url, data, success_callback, timeout_callback, error_callback, default_handle_errors, complete_callback, extra_settings ) {
	url = checkedManjaURL(url);
	var settings = {
		method: 'POST',
		url,
		data,
		dataType: 'json',
		success: function _mj_postJSON2_success( r, textStatus, jqXHR ) {
			intercept_ajax_backend_errors(jqXHR,textStatus,this);
			if( r && r.logout ) return mj_handle_invalid_session(r);
			if( default_handle_errors && r && r.hasOwnProperty('error') && r.error!==false ) return default_ajax_app_error_handler(r.error,r);
			if( success_callback ) return success_callback(r,jqXHR);
		},
		error: function _mj_postJSON2_error( jqXHR, textStatus, message ) {
			intercept_ajax_backend_errors(jqXHR,textStatus,this);
			if( textStatus==='timeout' && timeout_callback ) return timeout_callback();
			if( error_callback ) return error_callback(jqXHR,textStatus,message);
			return default_ajax_error_handler(jqXHR,textStatus,message);
		},
	};
	if( extra_settings ) {
		settings = Object.assign({},settings,extra_settings);
	}
	if( complete_callback ) {
		settings.complete = function _mj_postJSON2_complete( jqXHR, textStatus ) {
			complete_callback(jqXHR,textStatus,this);
		};
	}
	if( data instanceof FormData ) {
		settings.processData = false;
		settings.contentType = false;
	}
	return jQuery.ajax(settings);
}

function postToBackendSimple(url, complete_callback) {
	url = checkedManjaURL(url);
	var settings = {
		method: 'POST',
		url
	};
	if( complete_callback ) {
		settings.complete = function _mj_postJSON2_complete( jqXHR, textStatus ) {
			complete_callback(jqXHR, textStatus,this);
		};
	}
	jQuery.ajax(settings);
}

function getFromBackend( url, data, cache, success_callback, timeout_callback, error_callback, default_handle_errors ) {
	url = checkedManjaURL(url);
	// add our cache-tag to urls (varies by release, so after a manja update, users caches are invalidated ..)
	url += (url.indexOf('?')===-1?'?':'&')+window.mj.cutag0;
	//if( !mj.minify ) url += '&minify=off';
	return jQuery.ajax( {
		method: 'GET',
		url,
		data,
		dataType: 'json',
		cache: !!cache,
		success: function _mj_getJSON2_success( r, textStatus, jqXHR ) {
			intercept_ajax_backend_errors(jqXHR,textStatus,this);
			if( r && r.logout ) return mj_handle_invalid_session(r);
			if( default_handle_errors && r && r.hasOwnProperty('error') && r.error!==false ) return default_ajax_app_error_handler(r.error,r);
			if( success_callback ) return success_callback(r,jqXHR);
		},
		error: function _mj_getJSON2_error( jqXHR, textStatus, message ) {
			intercept_ajax_backend_errors(jqXHR,textStatus,this);
			if( textStatus=='timeout' && timeout_callback ) return timeout_callback();
			if( error_callback ) return error_callback(jqXHR,textStatus,message);
			return default_ajax_error_handler(jqXHR,textStatus,message);
		},
	} );
}


function getCachedScript( url, options ) {
	url = checkedManjaURL(url);
	return jQuery.ajax(
		jQuery.extend(
			options||{},
			{
				dataType: 'script',
				cache: true,
				url
			}
		)
	);
}

function cancelBackendRequest( jqXHR ) {
	if( jqXHR!==null && jqXHR.state && jqXHR.state()==='pending' ) {
		// ABORT pending request
		// console.log(['ABORTING list-counts request.']);
		jqXHR.abort();
		return null;
	}
	return jqXHR;
}


function downloadFileWithProgress( url, filename, success_callback, error_callback ) {
	startProgress();
	fetch( url )
		.then( (response) => {
			const disposition = response.headers.get('Content-Disposition');
			if( disposition ) {
				filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
				if( filename.toLowerCase().startsWith("utf-8''") ) {
					filename = decodeURIComponent(filename.replace(/utf-8''/i, ''));
				} else {
					filename = filename.replace(/['"]/g, '');
				}
			}
			return response.blob();
		} )
		.then( (blob) => {
			const file = new File([blob],filename,{type:blob.type});
			const newURL = URL.createObjectURL(file);

			let link = document.createElement('a');
			link.href = newURL;
			link.download = filename;
			document.body.appendChild(link);
			link.click();
			setTimeout( function() {
				document.body.removeChild(link);
				stopProgress();
				URL.revokeObjectURL(newURL);
				if( success_callback ) success_callback();
			}, 0 );
		} )
		.catch( (reason) => {
			stopProgress();
			if( error_callback ) error_callback();
		});
}

function downloadFileWithProgressAsPost( url, filename, postdata, success_callback, error_callback) {
	startProgress();
	let fetchOptions = {
		credentials: 'include',
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
			'X-CSRF-Token': window.mj.csrf_token
		},
		body: new URLSearchParams( postdata ),
	};
	if( window.mj.is_guest_session ) {
		fetchOptions.headers['X-CSRF-From-Guest-Session'] = '1';
	}
	fetch( url, fetchOptions )
		.then( (response) => {
			const disposition = response.headers.get('Content-Disposition');
			if( disposition ) {
				filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
				if( filename.toLowerCase().startsWith("utf-8''") ) {
					filename = decodeURIComponent(filename.replace(/utf-8''/i, ''));
				} else {
					filename = filename.replace(/['"]/g, '');
				}
			}
			return response.blob();
		} )
		.then( (blob) => {
			const file = new File([blob],filename,{type:blob.type});
			const newURL = URL.createObjectURL(file);

			let link = document.createElement('a');
			link.href = newURL;
			link.download = filename;
			document.body.appendChild(link);
			link.click();
			setTimeout( function() {
				document.body.removeChild(link);
				stopProgress();
				URL.revokeObjectURL(newURL);
				if( success_callback ) success_callback();
			}, 0 );
		} )
		.catch( (reason) => {
			stopProgress();
			if( error_callback ) error_callback();
		});
}



export {
	// eslint-disable-next-line import/no-unused-modules
	initManjaBackendFetch,

	default_ajax_error_handler,
	default_ajax_app_error_handler,

	postToBackend,
	postToBackend2,
	postToBackendSimple,
	getFromBackend,
	getCachedScript,
	cancelBackendRequest,

	downloadFileWithProgress,
	downloadFileWithProgressAsPost,
};

